import React from 'react';
import { PlusCalculator } from '@finect/tabular-icons/plusCalculator';
import { PlusMessages } from '@finect/tabular-icons/plusMessages';
import { PlusProfile } from '@finect/tabular-icons/plusProfile';
import { Panel, PanelServices, Pills } from './sections';

export const tabsData = [
  {
    id: 'calculadoras',
    tab: 'Calculadoras',
    metaTitle: 'Calculadoras financieras - Finect Plus',
    metaDescription: 'Utiliza nuestras calculadoras financieras para planificar tu futuro en Finect Plus',
    content: props => <Pills {...props} />,
    icon: <PlusCalculator size="28" />
  },
  {
    id: 'perfil-financiero',
    tab: 'Perfil Financiero',
    metaTitle: 'Mi perfil financiero - Finect Plus',
    metaDescription: 'Tu perfil financiero personalizado en Finect Plus',
    content: props => <Panel {...props} />,
    icon: <PlusProfile size="28" />
  },
  {
    id: 'asesoramiento',
    tab: 'Asesoramiento',
    metaTitle: 'Asesoramiento financiero - Finect Plus',
    metaDescription: 'Recibe asesoramiento financiero personalizado',
    content: props => <PanelServices {...props} />,
    icon: <PlusMessages size="28" />
  }
];
